import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "../components/PageHero";
import { fetchNews } from "../lib/api";

export default function Blog() {
  const [news, setNews] = useState([]);
  const [filter, setFilter] = useState("Tutte");

  useEffect(() => {
    fetchNews().then(setNews).catch(() => {});
  }, []);

  const categories = ["Tutte", ...Array.from(new Set(news.map((n) => n.categoria)))];
  const visible = filter === "Tutte" ? news : news.filter((n) => n.categoria === filter);

  return (
    <div data-testid="page-blog">
      <PageHero
        eyebrow="News · Diario della scuola"
        title="Dalla scuola,"
        italic="ogni settimana."
        subtitle="Racconti, risultati, annunci. La vita di Trinity Musical School e Amici per la Musica APS."
      />

      <section className="py-20 px-6 md:px-12 lg:px-24 max-w-[1400px] mx-auto">
        <div className="flex flex-wrap gap-3 mb-12" data-testid="blog-filters">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              data-testid={`blog-filter-${cat.toLowerCase()}`}
              className={`px-5 py-2.5 text-[11px] tracking-eyebrow rounded-sm border transition-all ${
                filter === cat
                  ? "bg-[#A3133A] text-white border-[#A3133A]"
                  : "border-[#A3133A]/30 text-[#1C1C1C] hover:border-[#A3133A] hover:text-[#A3133A]"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#A3133A]/15 border border-[#A3133A]/15">
          {visible.map((n) => (
            <Link
              key={n.id}
              to={`/blog/${n.id}`}
              data-testid={`blog-item-${n.id}`}
              className="group block bg-[#FBFBF9]"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={n.immagine}
                  alt={n.titolo}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-8">
                <div className="text-[10px] tracking-eyebrow text-[#A3133A] mb-3">
                  {n.categoria} · {new Date(n.data).toLocaleDateString("it-IT", { day: "2-digit", month: "long", year: "numeric" })}
                </div>
                <h3 className="font-serif-display text-3xl text-[#1C1C1C] mb-3 leading-tight">{n.titolo}</h3>
                <p className="text-sm text-[#5C5C5C] leading-relaxed line-clamp-3 mb-4">{n.estratto}</p>
                <span className="text-[12px] tracking-eyebrow text-[#A3133A] inline-flex items-center gap-2 link-underline">
                  Leggi l'articolo <ArrowRight size={12} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
